import { createStorage } from '@aviata/storage';

const create = (consumerTokenKey: string) => {
  const storage = createStorage(localStorage);

  const setConsumerToken = (token: string) =>
    storage.set(consumerTokenKey, token);
  const getConsumerToken = () => storage.get(consumerTokenKey, '');
  const removeConsumerToken = () => storage.remove(consumerTokenKey);

  return {
    setConsumerToken,
    getConsumerToken,
    removeConsumerToken,
  };
};

export const tokenStorage = { model: { create } };
